import React, { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

// 旧・指導実績一覧ページ。統計ページの明細タブに統合済み。
// 店舗フィルタ等のURLパラメータは引き継ぐ (詳細 /portal/metrics/records/:id は独立ルートのまま)
export const MetricsRecordsPage: FC = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.set('tab', 'records')
  return <Navigate to={`/portal/metrics?${params.toString()}`} replace />
}
